import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults, validateParameters } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\SiteInertiaController::maintenance
* @see app/Http/Controllers/SiteInertiaController.php:713
* @route '/bao-tri'
*/
export const maintenance = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: maintenance.url(options),
    method: 'get',
})

maintenance.definition = {
    methods: ["get","head"],
    url: '/bao-tri',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::maintenance
* @see app/Http/Controllers/SiteInertiaController.php:713
* @route '/bao-tri'
*/
maintenance.url = (options?: RouteQueryOptions) => {
    return maintenance.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::maintenance
* @see app/Http/Controllers/SiteInertiaController.php:713
* @route '/bao-tri'
*/
maintenance.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: maintenance.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::maintenance
* @see app/Http/Controllers/SiteInertiaController.php:713
* @route '/bao-tri'
*/
maintenance.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: maintenance.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::maintenance
* @see app/Http/Controllers/SiteInertiaController.php:713
* @route '/bao-tri'
*/
const maintenanceForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: maintenance.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::maintenance
* @see app/Http/Controllers/SiteInertiaController.php:713
* @route '/bao-tri'
*/
maintenanceForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: maintenance.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::maintenance
* @see app/Http/Controllers/SiteInertiaController.php:713
* @route '/bao-tri'
*/
maintenanceForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: maintenance.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

maintenance.form = maintenanceForm

/**
* @see \App\Http\Controllers\SiteInertiaController::home
* @see app/Http/Controllers/SiteInertiaController.php:59
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::home
* @see app/Http/Controllers/SiteInertiaController.php:59
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::home
* @see app/Http/Controllers/SiteInertiaController.php:59
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::home
* @see app/Http/Controllers/SiteInertiaController.php:59
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::home
* @see app/Http/Controllers/SiteInertiaController.php:59
* @route '/'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::home
* @see app/Http/Controllers/SiteInertiaController.php:59
* @route '/'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::home
* @see app/Http/Controllers/SiteInertiaController.php:59
* @route '/'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see \App\Http\Controllers\SiteInertiaController::search
* @see app/Http/Controllers/SiteInertiaController.php:435
* @route '/dich-vu'
*/
export const search = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

search.definition = {
    methods: ["get","head"],
    url: '/dich-vu',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::search
* @see app/Http/Controllers/SiteInertiaController.php:435
* @route '/dich-vu'
*/
search.url = (options?: RouteQueryOptions) => {
    return search.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::search
* @see app/Http/Controllers/SiteInertiaController.php:435
* @route '/dich-vu'
*/
search.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::search
* @see app/Http/Controllers/SiteInertiaController.php:435
* @route '/dich-vu'
*/
search.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: search.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::search
* @see app/Http/Controllers/SiteInertiaController.php:435
* @route '/dich-vu'
*/
const searchForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::search
* @see app/Http/Controllers/SiteInertiaController.php:435
* @route '/dich-vu'
*/
searchForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::search
* @see app/Http/Controllers/SiteInertiaController.php:435
* @route '/dich-vu'
*/
searchForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

search.form = searchForm

/**
* @see \App\Http\Controllers\SiteInertiaController::checkout
* @see app/Http/Controllers/SiteInertiaController.php:678
* @route '/checkout'
*/
export const checkout = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: checkout.url(options),
    method: 'get',
})

checkout.definition = {
    methods: ["get","head"],
    url: '/checkout',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::checkout
* @see app/Http/Controllers/SiteInertiaController.php:678
* @route '/checkout'
*/
checkout.url = (options?: RouteQueryOptions) => {
    return checkout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::checkout
* @see app/Http/Controllers/SiteInertiaController.php:678
* @route '/checkout'
*/
checkout.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: checkout.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::checkout
* @see app/Http/Controllers/SiteInertiaController.php:678
* @route '/checkout'
*/
checkout.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: checkout.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::checkout
* @see app/Http/Controllers/SiteInertiaController.php:678
* @route '/checkout'
*/
const checkoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkout.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::checkout
* @see app/Http/Controllers/SiteInertiaController.php:678
* @route '/checkout'
*/
checkoutForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkout.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::checkout
* @see app/Http/Controllers/SiteInertiaController.php:678
* @route '/checkout'
*/
checkoutForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkout.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

checkout.form = checkoutForm

/**
* @see \App\Http\Controllers\SiteInertiaController::sitemap
* @see app/Http/Controllers/SiteInertiaController.php:730
* @route '/sitemap'
*/
export const sitemap = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sitemap.url(options),
    method: 'get',
})

sitemap.definition = {
    methods: ["get","head"],
    url: '/sitemap',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::sitemap
* @see app/Http/Controllers/SiteInertiaController.php:730
* @route '/sitemap'
*/
sitemap.url = (options?: RouteQueryOptions) => {
    return sitemap.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::sitemap
* @see app/Http/Controllers/SiteInertiaController.php:730
* @route '/sitemap'
*/
sitemap.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::sitemap
* @see app/Http/Controllers/SiteInertiaController.php:730
* @route '/sitemap'
*/
sitemap.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sitemap.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::sitemap
* @see app/Http/Controllers/SiteInertiaController.php:730
* @route '/sitemap'
*/
const sitemapForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::sitemap
* @see app/Http/Controllers/SiteInertiaController.php:730
* @route '/sitemap'
*/
sitemapForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::sitemap
* @see app/Http/Controllers/SiteInertiaController.php:730
* @route '/sitemap'
*/
sitemapForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sitemap.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sitemap.form = sitemapForm

/**
* @see \App\Http\Controllers\SiteInertiaController::about
* @see app/Http/Controllers/SiteInertiaController.php:978
* @route '/ve-chung-toi'
*/
export const about = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

about.definition = {
    methods: ["get","head"],
    url: '/ve-chung-toi',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::about
* @see app/Http/Controllers/SiteInertiaController.php:978
* @route '/ve-chung-toi'
*/
about.url = (options?: RouteQueryOptions) => {
    return about.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::about
* @see app/Http/Controllers/SiteInertiaController.php:978
* @route '/ve-chung-toi'
*/
about.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::about
* @see app/Http/Controllers/SiteInertiaController.php:978
* @route '/ve-chung-toi'
*/
about.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: about.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::about
* @see app/Http/Controllers/SiteInertiaController.php:978
* @route '/ve-chung-toi'
*/
const aboutForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::about
* @see app/Http/Controllers/SiteInertiaController.php:978
* @route '/ve-chung-toi'
*/
aboutForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::about
* @see app/Http/Controllers/SiteInertiaController.php:978
* @route '/ve-chung-toi'
*/
aboutForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

about.form = aboutForm

/**
* @see \App\Http\Controllers\SiteInertiaController::aboutV2
* @see app/Http/Controllers/SiteInertiaController.php:992
* @route '/ve-chung-toi-v2'
*/
export const aboutV2 = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutV2.url(options),
    method: 'get',
})

aboutV2.definition = {
    methods: ["get","head"],
    url: '/ve-chung-toi-v2',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::aboutV2
* @see app/Http/Controllers/SiteInertiaController.php:992
* @route '/ve-chung-toi-v2'
*/
aboutV2.url = (options?: RouteQueryOptions) => {
    return aboutV2.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::aboutV2
* @see app/Http/Controllers/SiteInertiaController.php:992
* @route '/ve-chung-toi-v2'
*/
aboutV2.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutV2.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::aboutV2
* @see app/Http/Controllers/SiteInertiaController.php:992
* @route '/ve-chung-toi-v2'
*/
aboutV2.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: aboutV2.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::aboutV2
* @see app/Http/Controllers/SiteInertiaController.php:992
* @route '/ve-chung-toi-v2'
*/
const aboutV2Form = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: aboutV2.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::aboutV2
* @see app/Http/Controllers/SiteInertiaController.php:992
* @route '/ve-chung-toi-v2'
*/
aboutV2Form.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: aboutV2.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::aboutV2
* @see app/Http/Controllers/SiteInertiaController.php:992
* @route '/ve-chung-toi-v2'
*/
aboutV2Form.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: aboutV2.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

aboutV2.form = aboutV2Form

/**
* @see \App\Http\Controllers\SiteInertiaController::rateDetail
* @see app/Http/Controllers/SiteInertiaController.php:566
* @route '/api/booking-rate/{mappingCode}'
*/
export const rateDetail = (args: { mappingCode: string | number } | [mappingCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: rateDetail.url(args, options),
    method: 'get',
})

rateDetail.definition = {
    methods: ["get","head"],
    url: '/api/booking-rate/{mappingCode}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::rateDetail
* @see app/Http/Controllers/SiteInertiaController.php:566
* @route '/api/booking-rate/{mappingCode}'
*/
rateDetail.url = (args: { mappingCode: string | number } | [mappingCode: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { mappingCode: args }
    }

    if (Array.isArray(args)) {
        args = {
            mappingCode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        mappingCode: args.mappingCode,
    }

    return rateDetail.definition.url
            .replace('{mappingCode}', parsedArgs.mappingCode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::rateDetail
* @see app/Http/Controllers/SiteInertiaController.php:566
* @route '/api/booking-rate/{mappingCode}'
*/
rateDetail.get = (args: { mappingCode: string | number } | [mappingCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: rateDetail.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::rateDetail
* @see app/Http/Controllers/SiteInertiaController.php:566
* @route '/api/booking-rate/{mappingCode}'
*/
rateDetail.head = (args: { mappingCode: string | number } | [mappingCode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: rateDetail.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::rateDetail
* @see app/Http/Controllers/SiteInertiaController.php:566
* @route '/api/booking-rate/{mappingCode}'
*/
const rateDetailForm = (args: { mappingCode: string | number } | [mappingCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rateDetail.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::rateDetail
* @see app/Http/Controllers/SiteInertiaController.php:566
* @route '/api/booking-rate/{mappingCode}'
*/
rateDetailForm.get = (args: { mappingCode: string | number } | [mappingCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rateDetail.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::rateDetail
* @see app/Http/Controllers/SiteInertiaController.php:566
* @route '/api/booking-rate/{mappingCode}'
*/
rateDetailForm.head = (args: { mappingCode: string | number } | [mappingCode: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rateDetail.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

rateDetail.form = rateDetailForm

/**
* @see \App\Http\Controllers\SiteInertiaController::postDetail
* @see app/Http/Controllers/SiteInertiaController.php:1362
* @route '/api/post/{model}/{subjectId}'
*/
export const postDetail = (args: { model: string | number, subjectId: string | number } | [model: string | number, subjectId: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: postDetail.url(args, options),
    method: 'get',
})

postDetail.definition = {
    methods: ["get","head"],
    url: '/api/post/{model}/{subjectId}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::postDetail
* @see app/Http/Controllers/SiteInertiaController.php:1362
* @route '/api/post/{model}/{subjectId}'
*/
postDetail.url = (args: { model: string | number, subjectId: string | number } | [model: string | number, subjectId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            model: args[0],
            subjectId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        model: args.model,
        subjectId: args.subjectId,
    }

    return postDetail.definition.url
            .replace('{model}', parsedArgs.model.toString())
            .replace('{subjectId}', parsedArgs.subjectId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::postDetail
* @see app/Http/Controllers/SiteInertiaController.php:1362
* @route '/api/post/{model}/{subjectId}'
*/
postDetail.get = (args: { model: string | number, subjectId: string | number } | [model: string | number, subjectId: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: postDetail.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::postDetail
* @see app/Http/Controllers/SiteInertiaController.php:1362
* @route '/api/post/{model}/{subjectId}'
*/
postDetail.head = (args: { model: string | number, subjectId: string | number } | [model: string | number, subjectId: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: postDetail.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::postDetail
* @see app/Http/Controllers/SiteInertiaController.php:1362
* @route '/api/post/{model}/{subjectId}'
*/
const postDetailForm = (args: { model: string | number, subjectId: string | number } | [model: string | number, subjectId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: postDetail.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::postDetail
* @see app/Http/Controllers/SiteInertiaController.php:1362
* @route '/api/post/{model}/{subjectId}'
*/
postDetailForm.get = (args: { model: string | number, subjectId: string | number } | [model: string | number, subjectId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: postDetail.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::postDetail
* @see app/Http/Controllers/SiteInertiaController.php:1362
* @route '/api/post/{model}/{subjectId}'
*/
postDetailForm.head = (args: { model: string | number, subjectId: string | number } | [model: string | number, subjectId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: postDetail.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

postDetail.form = postDetailForm

/**
* @see \App\Http\Controllers\SiteInertiaController::searchRatesApi
* @see app/Http/Controllers/SiteInertiaController.php:596
* @route '/api/search-rates'
*/
export const searchRatesApi = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchRatesApi.url(options),
    method: 'get',
})

searchRatesApi.definition = {
    methods: ["get","head"],
    url: '/api/search-rates',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::searchRatesApi
* @see app/Http/Controllers/SiteInertiaController.php:596
* @route '/api/search-rates'
*/
searchRatesApi.url = (options?: RouteQueryOptions) => {
    return searchRatesApi.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::searchRatesApi
* @see app/Http/Controllers/SiteInertiaController.php:596
* @route '/api/search-rates'
*/
searchRatesApi.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchRatesApi.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::searchRatesApi
* @see app/Http/Controllers/SiteInertiaController.php:596
* @route '/api/search-rates'
*/
searchRatesApi.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: searchRatesApi.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::searchRatesApi
* @see app/Http/Controllers/SiteInertiaController.php:596
* @route '/api/search-rates'
*/
const searchRatesApiForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchRatesApi.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::searchRatesApi
* @see app/Http/Controllers/SiteInertiaController.php:596
* @route '/api/search-rates'
*/
searchRatesApiForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchRatesApi.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::searchRatesApi
* @see app/Http/Controllers/SiteInertiaController.php:596
* @route '/api/search-rates'
*/
searchRatesApiForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchRatesApi.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

searchRatesApi.form = searchRatesApiForm

/**
* @see \App\Http\Controllers\SiteInertiaController::policyPage
* @see app/Http/Controllers/SiteInertiaController.php:1466
* @route '/dieu-khoan-dich-vu/{slug?}'
*/
export const policyPage = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: policyPage.url(args, options),
    method: 'get',
})

policyPage.definition = {
    methods: ["get","head"],
    url: '/dieu-khoan-dich-vu/{slug?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::policyPage
* @see app/Http/Controllers/SiteInertiaController.php:1466
* @route '/dieu-khoan-dich-vu/{slug?}'
*/
policyPage.url = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "slug",
    ])

    const parsedArgs = {
        slug: args?.slug,
    }

    return policyPage.definition.url
            .replace('{slug?}', parsedArgs.slug?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::policyPage
* @see app/Http/Controllers/SiteInertiaController.php:1466
* @route '/dieu-khoan-dich-vu/{slug?}'
*/
policyPage.get = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: policyPage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::policyPage
* @see app/Http/Controllers/SiteInertiaController.php:1466
* @route '/dieu-khoan-dich-vu/{slug?}'
*/
policyPage.head = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: policyPage.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::policyPage
* @see app/Http/Controllers/SiteInertiaController.php:1466
* @route '/dieu-khoan-dich-vu/{slug?}'
*/
const policyPageForm = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: policyPage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::policyPage
* @see app/Http/Controllers/SiteInertiaController.php:1466
* @route '/dieu-khoan-dich-vu/{slug?}'
*/
policyPageForm.get = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: policyPage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::policyPage
* @see app/Http/Controllers/SiteInertiaController.php:1466
* @route '/dieu-khoan-dich-vu/{slug?}'
*/
policyPageForm.head = (args?: { slug?: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: policyPage.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

policyPage.form = policyPageForm

/**
* @see \App\Http\Controllers\SiteInertiaController::faq
* @see app/Http/Controllers/SiteInertiaController.php:1432
* @route '/cau-hoi-thuong-gap'
*/
export const faq = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

faq.definition = {
    methods: ["get","head"],
    url: '/cau-hoi-thuong-gap',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::faq
* @see app/Http/Controllers/SiteInertiaController.php:1432
* @route '/cau-hoi-thuong-gap'
*/
faq.url = (options?: RouteQueryOptions) => {
    return faq.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::faq
* @see app/Http/Controllers/SiteInertiaController.php:1432
* @route '/cau-hoi-thuong-gap'
*/
faq.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::faq
* @see app/Http/Controllers/SiteInertiaController.php:1432
* @route '/cau-hoi-thuong-gap'
*/
faq.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: faq.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::faq
* @see app/Http/Controllers/SiteInertiaController.php:1432
* @route '/cau-hoi-thuong-gap'
*/
const faqForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::faq
* @see app/Http/Controllers/SiteInertiaController.php:1432
* @route '/cau-hoi-thuong-gap'
*/
faqForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::faq
* @see app/Http/Controllers/SiteInertiaController.php:1432
* @route '/cau-hoi-thuong-gap'
*/
faqForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: faq.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

faq.form = faqForm

/**
* @see \App\Http\Controllers\SiteInertiaController::availableVoucher
* @see app/Http/Controllers/SiteInertiaController.php:1281
* @route '/available-voucher'
*/
export const availableVoucher = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableVoucher.url(options),
    method: 'get',
})

availableVoucher.definition = {
    methods: ["get","head"],
    url: '/available-voucher',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::availableVoucher
* @see app/Http/Controllers/SiteInertiaController.php:1281
* @route '/available-voucher'
*/
availableVoucher.url = (options?: RouteQueryOptions) => {
    return availableVoucher.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::availableVoucher
* @see app/Http/Controllers/SiteInertiaController.php:1281
* @route '/available-voucher'
*/
availableVoucher.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableVoucher.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::availableVoucher
* @see app/Http/Controllers/SiteInertiaController.php:1281
* @route '/available-voucher'
*/
availableVoucher.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: availableVoucher.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::availableVoucher
* @see app/Http/Controllers/SiteInertiaController.php:1281
* @route '/available-voucher'
*/
const availableVoucherForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableVoucher.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::availableVoucher
* @see app/Http/Controllers/SiteInertiaController.php:1281
* @route '/available-voucher'
*/
availableVoucherForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableVoucher.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::availableVoucher
* @see app/Http/Controllers/SiteInertiaController.php:1281
* @route '/available-voucher'
*/
availableVoucherForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableVoucher.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

availableVoucher.form = availableVoucherForm

/**
* @see \App\Http\Controllers\SiteInertiaController::pages
* @see app/Http/Controllers/SiteInertiaController.php:1079
* @route '/{slug}'
*/
export const pages = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pages.url(args, options),
    method: 'get',
})

pages.definition = {
    methods: ["get","head"],
    url: '/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::pages
* @see app/Http/Controllers/SiteInertiaController.php:1079
* @route '/{slug}'
*/
pages.url = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        slug: args.slug,
    }

    return pages.definition.url
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::pages
* @see app/Http/Controllers/SiteInertiaController.php:1079
* @route '/{slug}'
*/
pages.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::pages
* @see app/Http/Controllers/SiteInertiaController.php:1079
* @route '/{slug}'
*/
pages.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pages.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::pages
* @see app/Http/Controllers/SiteInertiaController.php:1079
* @route '/{slug}'
*/
const pagesForm = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::pages
* @see app/Http/Controllers/SiteInertiaController.php:1079
* @route '/{slug}'
*/
pagesForm.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::pages
* @see app/Http/Controllers/SiteInertiaController.php:1079
* @route '/{slug}'
*/
pagesForm.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pages.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

pages.form = pagesForm

/**
* @see \App\Http\Controllers\SiteInertiaController::onlineTicketReact
* @see app/Http/Controllers/SiteInertiaController.php:1148
* @route '/online-ticket/{ticketId}'
*/
export const onlineTicketReact = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: onlineTicketReact.url(args, options),
    method: 'get',
})

onlineTicketReact.definition = {
    methods: ["get","head"],
    url: '/online-ticket/{ticketId}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SiteInertiaController::onlineTicketReact
* @see app/Http/Controllers/SiteInertiaController.php:1148
* @route '/online-ticket/{ticketId}'
*/
onlineTicketReact.url = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { ticketId: args }
    }

    if (Array.isArray(args)) {
        args = {
            ticketId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        ticketId: args.ticketId,
    }

    return onlineTicketReact.definition.url
            .replace('{ticketId}', parsedArgs.ticketId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SiteInertiaController::onlineTicketReact
* @see app/Http/Controllers/SiteInertiaController.php:1148
* @route '/online-ticket/{ticketId}'
*/
onlineTicketReact.get = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: onlineTicketReact.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::onlineTicketReact
* @see app/Http/Controllers/SiteInertiaController.php:1148
* @route '/online-ticket/{ticketId}'
*/
onlineTicketReact.head = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: onlineTicketReact.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::onlineTicketReact
* @see app/Http/Controllers/SiteInertiaController.php:1148
* @route '/online-ticket/{ticketId}'
*/
const onlineTicketReactForm = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: onlineTicketReact.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::onlineTicketReact
* @see app/Http/Controllers/SiteInertiaController.php:1148
* @route '/online-ticket/{ticketId}'
*/
onlineTicketReactForm.get = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: onlineTicketReact.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SiteInertiaController::onlineTicketReact
* @see app/Http/Controllers/SiteInertiaController.php:1148
* @route '/online-ticket/{ticketId}'
*/
onlineTicketReactForm.head = (args: { ticketId: string | number } | [ticketId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: onlineTicketReact.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

onlineTicketReact.form = onlineTicketReactForm

const SiteInertiaController = { maintenance, home, search, checkout, sitemap, about, aboutV2, rateDetail, postDetail, searchRatesApi, policyPage, faq, availableVoucher, pages, onlineTicketReact }

export default SiteInertiaController